import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	startDateLaterDueDate: {
		id: 'business-timeline.timeline-view.chart-item-content.start-date-later-due-date',
		defaultMessage: 'Start date must be before Due date.',
		description:
			'Heading text. Gives context for a bar that has incorrect start date and due date. Shown on a warning tooltip when user hovers on the warning icon of a bar which has the start date after the due date.',
	},
});
